import { useRefreshUserClaimsMutation } from '../../userManagement/queries/refreshClaims.mutation.generated';

/**
 * Bumps the user's updated_at to trigger backend Firebase claim regeneration.
 * Call this before getIdToken(true) to ensure the fresh JWT has current claims.
 */
export const useRefreshUserClaims = () => {
  const [refreshClaims, { loading }] = useRefreshUserClaimsMutation();

  const refreshUserClaims = async (userId: number) => {
    try {
      const result = await refreshClaims({ variables: { userId } });
      return (result.data?.update_users?.affected_rows ?? 0) > 0;
    } catch (err) {
      console.error('Failed to refresh user claims:', err);
      return false;
    }
  };

  return { refreshUserClaims, loading };
};
